module.exports = {"540230100":"康马镇","540230200":"南尼乡","540230201":"少岗乡","540230202":"康如乡","540230203":"萨玛达乡","540230204":"嘎拉乡","540230205":"涅如堆乡","540230206":"涅如麦乡","540230207":"雄章乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540230.json
// module id = 2833
// module chunks = 0